<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="true">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-stkpi20 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-stkpi20>
    </div>
    }
    <!-- @if(detailVisible){
    <div class="top-1 border-1 border-2 border-green-400">
      <app-stkpi20-detail (onFormReady)="doFormReady($event,PageKind.detail)">
      </app-stkpi20-detail>
    </div>
    } -->
  </div>
<div>
